/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Title_1Inputs */

const et_benefits_title_1 = /** @type {(inputs: Benefits_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nähtavus`)
};

const en_benefits_title_1 = /** @type {(inputs: Benefits_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility`)
};

/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {Benefits_Title_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_title_1 = /** @type {((inputs?: Benefits_Title_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Title_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_title_1(inputs)
	return en_benefits_title_1(inputs)
});